import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["loginEmail", "password", "confirmation", "passwordNotice"];
  static values = { confirmationMessage: String };

  async saveLoginAccess(event) {
    if (!window.confirm(this.confirmationMessageValue)) return;

    const button = event.currentTarget;
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const data = new FormData();

    data.append("authenticity_token", token || "");
    data.append("ats_candidate[login_email]", this.loginEmailTarget.value);

    if (this.hasPasswordTarget) {
      data.append("ats_candidate[login_password]", this.passwordTarget.value);
      data.append("ats_candidate[login_password_confirmation]", this.confirmationTarget.value);
    }

    button.disabled = true;
    try {
      const response = await fetch(button.dataset.url, {
        method: "PATCH",
        body: data,
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      });

      if (response.redirected) {
        window.location.assign(response.url);
      } else {
        window.location.reload();
      }
    } finally {
      button.disabled = false;
    }
  }

  suggestPassword() {
    const lower = "abcdefghijkmnopqrstuvwxyz";
    const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
    const numbers = "23456789";
    const symbols = "!@#$%&*";
    const all = lower + upper + numbers + symbols;
    const chars = [
      this.randomCharacter(lower),
      this.randomCharacter(upper),
      this.randomCharacter(numbers),
      this.randomCharacter(symbols),
    ];

    while (chars.length < 12) chars.push(this.randomCharacter(all));
    chars.sort(() => Math.random() - 0.5);
    const password = chars.join("");

    this.passwordTarget.value = password;
    this.confirmationTarget.value = password;
    this.setVisibility(false);
    this.showPasswordNotice();
    this.passwordTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.confirmationTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }

  async copyPassword() {
    const password = this.passwordTarget.value;
    if (!password) {
      this.showPasswordNotice("generate");
      return;
    }

    try {
      await navigator.clipboard.writeText(password);
    } catch (error) {
      const temporaryInput = document.createElement("textarea");
      temporaryInput.value = password;
      temporaryInput.style.position = "fixed";
      temporaryInput.style.opacity = "0";
      document.body.appendChild(temporaryInput);
      temporaryInput.select();
      document.execCommand("copy");
      temporaryInput.remove();
    }

    this.showPasswordNotice("copied");
  }

  showPasswordNotice(state = "generated") {
    if (!this.hasPasswordNoticeTarget) return;

    const message = this.passwordNoticeTarget.dataset[`${state}Message`];
    this.passwordNoticeTarget.textContent = message;
    this.passwordNoticeTarget.classList.remove("d-none");
  }

  toggleField(event) {
    const field = this[`${event.currentTarget.dataset.field}Target`];
    const visible = field.type === "password";
    field.type = visible ? "text" : "password";
    const icon = event.currentTarget.querySelector("i");
    icon.classList.toggle("fa-eye", !visible);
    icon.classList.toggle("fa-eye-slash", visible);
  }

  setVisibility(visible) {
    this.passwordTarget.type = visible ? "text" : "password";
    this.confirmationTarget.type = visible ? "text" : "password";
  }

  randomCharacter(characters) {
    return characters[Math.floor(Math.random() * characters.length)];
  }
}
